import React from 'react'

import {useState,useEffect} from 'react';
import ReactLoading from "react-loading";
import axios from 'axios';
import { CSVLink, CSVDownload } from "react-csv";
import { toast } from 'react-toastify';
const Form = () => {
  const [Name, setName] = useState('');
  const [Email, setEmail] = useState('');
  const [Mobile, setMobile] = useState('');
  const [Whatsapp, setWhatsapp] = useState('');
  const [Domain, setDomain] = useState('');
  const [Branch, setBranch] = useState('');
  const [Reg, setReg] = useState('');
  const [Year, setYear] = useState('');
  const [review, setreview] = useState('');
  const [dob, setdob] = useState('');
  const [api, setApi] = useState([]);
  const [loading, setLoading] = useState(true);

// CheckBox Input
const [formData2, setFormData] = useState("");
  const [checked, setChecked] = useState([]); // categories
  const [categories, setCategories] = useState([
    { _id: "5d7c7653427efd4400201e0e", name: "Graphic designing & Video editing", slug: "Graphic-designing-&-Video-editing" },
    { _id: "5d7c7662427efd4400201e11", name: "Social media & Content writing", slug: "Social-media-&-Content-writing" },
    { _id: "5d7c79df427efd4400201e1e", name: "Technical team", slug: "Technical-team" },
    { _id: "5d7c7662427efd4400201e12", name: "Event management & Marketing", slug: "Event-management-&-Marketing" },
    { _id: "5d7c79df427efd4400201e14", name: "Public Speaking", slug: "Public-Speaking" }
  ]);


  
  async function fetchMyData() {
    try {
      setLoading(true);
      const data = (
        await axios.get(
          `https://mysterious-reaches-39055.herokuapp.com/api/data`
        )
      ).data;
      console.log(data);
      setApi(data);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  }


  useEffect(() => {
    fetchMyData();
  }, []);



//   const handleSubmit = (e)=> {
//     e.preventDefault();
//     console.log(checked)

// const  formData = {Name,Email,Mobile,Whatsapp,Domain,Branch,Year,checked,dob,Reg,review};
// console.log(formData);
// //return;
// axios.get("http://localhost:8000/api/data")
// .then((response)=>{
//    console.log(response)
//    setApi(response.data)
//   console.log(response);
// });
// toast("Congratulation " +Name+ " Registration Sucessfull")
// //  e.target.reset();

// }
// useEffect(() => {
//     setFormData(new FormData());
//   }, []);
return (
  <div>
    {!loading ? (
      <div>
           <h2 style={{ color: "green" }}>Total Registrations :{api.length}</h2>
        {" "}
        <div className="col md-12" style={{ margin: "auto" }}>
          <button className="btn btn-success" onClick={fetchMyData}>
            Refresh
          </button>
          <button className="btn btn-info ">
            <CSVLink data={api}> Download Csv</CSVLink>
          </button>
        </div>
        <table className="table table-dark">
          <thead>
            <tr>
          <th>Sno</th>
              <th>Name</th>
              <th>Email</th>
              <th>Mobile</th>
              <th>Whatsapp</th>
              <th>Reg No.</th>
              <th>Branch</th>
              <th>Domain</th>
              <th>Year</th>
              <th>Review</th>
            </tr>
          </thead>
          <tbody>
            {api.map((post,idx) => (
              <tr key={post.name}>
              <td>{idx+1}</td>
                <td>{post.name}</td>
                <td>{post.email}</td>
                <td>{post.mobile}</td>
                <td>{post.wp}</td>
                <td>{post.reg}</td>
                <td>{post.branch}</td>

                <td>{post.domain}</td>
                <td>{post.year}</td>
                <td>{post.review}</td>
              </tr>
            ))}
          </tbody>
        </table>{" "}
      </div>
    ) : (
      <>
        <ReactLoading color={"#fffff"} height={"10%"} width={"10%"} />
      </>
    )}
  </div>
);
};

export default Form;
